export default __webpack_public_path__ + "static/media/bb115380cbad21ff961b5f734167f9e4.svg";